import { combineReducers } from 'redux';
// Import reducers
import table from './providers_panel_reducer';
import data from './providers_data_reducer';

export default combineReducers({
	table,
	data
});
